export interface Seo {
  id: number;
  title: string;
  page: string;
  keyword: string;
  slug: string;
  siteName: string;
  description: string;
  language: string;
  parentLanguage: string;
  image: string;
  content: string;
  createdAt: Date;
  updatedAt: Date;
}

export enum pageNumberSeo {
  Home = 1,
  Pricing,
  FAQs,
  TOS,
  Trial,
}
